import PartyIcon from "../../../public/assets/party-icon.svg";
import NavigationBar from "../../components/NavigationBar";
import PrimaryButton from "../../components/PrimaryButton";
import styles from "../styles/Navigation.module.scss";

export default function Navigation() {
  return (
    <div className={styles.main}>
      <div className={styles.background}>
        <NavigationBar></NavigationBar>
        <div className={styles.title}>
          <h1>Find friends to join your activity</h1>
          <PrimaryButton>Join HARTY</PrimaryButton>
        </div>
      </div>
      <PartyIcon className={styles.icon}></PartyIcon>
    </div>
  );
}
